import { StaticImage } from "gatsby-plugin-image";
import * as React from "react";

export class GroupPictures extends React.Component {
  render() {
    return (
      <div className="max-w-2xl flex flex-col gap-4">
        <StaticImage
          src="../assets/team.jpg"
          alt="Teamfoto"
          placeholder="blurred"
          className="rounded-3xl shadow-md"
        />
      </div>
    );
  }
}
